import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { RedoFeaturedIcon } from "@redotech/arbiter/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { TopStatus } from "@redotech/redo-customer-portal-shared/hooks/useReturnConfirmation/use-return-confirmation";
import Check from "@redotech/redo-icons/check.svg";
import ClockRefresh from "@redotech/redo-icons/clock-refresh_filled.svg";
import { assertNever } from "@redotech/util/type";
import { type ReactNode } from "react";

export function TopCard({
  status,
  title,
  subtitle,
  action,
  actionTitle,
  cancelButton,
}: {
  status: TopStatus;
  title: string;
  subtitle: string;
  action?: () => void;
  actionTitle?: string;
  cancelButton?: ReactNode;
}) {
  function getStatusIcon(status: TopStatus) {
    switch (status) {
      case TopStatus.SUCCESS:
        return <RedoFeaturedIcon color="success" Icon={Check} size="md" />;
      case TopStatus.WARNING:
        return (
          <RedoFeaturedIcon color="warning" Icon={ClockRefresh} size="md" />
        );
      case TopStatus.ERROR:
        return <RedoFeaturedIcon color="error" Icon={ClockRefresh} size="md" />;
      default:
        assertNever(status);
    }
  }
  return (
    <Flex data-ui="status-card" flexDirection="column" gap="lg">
      {getStatusIcon(status)}
      <Flex align="center" flexDirection="row" justify="space-between">
        <Flex flexDirection="column" gap="xxs">
          <Text as="h1" fontSize="xl" fontWeight="semibold">
            {title}
          </Text>
          <Text fontSize="sm" fontWeight="regular" textColor="secondary">
            {subtitle}
          </Text>
        </Flex>
        {cancelButton}
      </Flex>
      {action && actionTitle && (
        <RedoButton
          hierarchy="secondary"
          onClick={action}
          text={actionTitle}
          uiSelector="action-button"
        />
      )}
    </Flex>
  );
}
